import _ from 'lodash'
import { getCurrentEnvironment, uploadFileOnKhub, updateFileUriAndVersionId, getCSVContent,
uploadContentFromCsv, updateAsset, getAncestorName, uploadFileOnKhubWithReturn,doUploadForScorm } from '../api'

export const loadCurrentEnvironment = ({ state, commit }) => {
  if (_.isEmpty(state.currentEnvironment)) {
    return getCurrentEnvironment().then(environment => {
      commit('LOAD_CURRENT_ENVIRONMENT', environment)
      return environment
    })
  } else {
    return state.currentEnvironment
  }
}

export const uploadContent = ({ state, commit }, { learningSpaceId, contents, success, failure }) => {
  uploadFileOnKhub(learningSpaceId, contents, success, failure)
}

export const uploadContentAndGetUri = ({ state, commit }, { learningSpaceId, contents, success, failure }) => {
  return uploadFileOnKhubWithReturn(learningSpaceId, contents, success, failure)
}

export const uploadCSVFile = ({ state, commit }, { data, success }) => {
  getCSVContent(data, success)
}

export const uploadCSVContent = ({ state, commit }, { learningSpaceId, contents, success, failure }) => {
  uploadContentFromCsv(learningSpaceId, contents, success, failure)
}
export const uploadScormFile = ({ state, commit }, {owningLibraryId, fileData}) => {
  return doUploadForScorm(owningLibraryId, fileData).then(res => {
    return res
  })
}
export const updateFileUriAndVersionIdAfterS3Upload = ({ state, commit }, data) => {
  updateFileUriAndVersionId(data)
}

export const updateAssetMetaData = ({ state, commit }, data) => {
  return updateAsset(data)
}

export const createAsset = ({ state, commit }, data) => {
  return updateAsset(data)
}

export const loadAncestorName = ({ state, commit }, uuid) => {
  return getAncestorName(uuid)
}



// WEBPACK FOOTER //
// ./src/app/learningContent/vuex/actions.js